import { PATHS } from 'Libraries/routes.library';
import { useRouter } from 'next/router';
import { IconElipsFillSmall } from '@spinwise/react-component-library/IconElipsFillSmall';
import styles from './ReplayPreviewSport.module.scss';

export interface IReplayPreviewSport {
  id: number;
  category: string;
  time: string;
  date: string;
  user_name: string;
  win_amount: string;
  bet_amount: string;
  team_name: string;
  coefficient: number;
  bet_title: string;
  sport_name: string;
  image: {
    data: {
      attributes: {
        url;
      };
    };
  };
  team_logo: {
    data: {
      attributes: {
        url;
      };
    };
  };
  onClickReplay: Function;
}

const ReplayPreviewSport = (props: IReplayPreviewSport) => {
  const router = useRouter();
  return (
    <div className={styles.ReplayPreviewSport} onClick={() => router.push(PATHS.SPORTS)}>
      <div
        className={styles.image_container}
        style={{ background: `#1F0A4D url(${props?.image?.data?.attributes?.url}) no-repeat right top` }}
      >
        <div className={styles.top}>
          <p className={styles.sport_name}>{props.sport_name}</p>
          <div className={styles.date_container}>
            <p className={styles.date_text}>{props.category}</p>
            <IconElipsFillSmall />
            <p className={styles.date_text}>{props.date}</p>
          </div>
        </div>
        <div className={styles.bottom}>
          <p className={styles.user_name}>{props.user_name}</p>
          <p className={styles.win_amount}>{props.win_amount}</p>
        </div>
      </div>
      <div className={styles.description_container}>
        <div className={styles.bet_container}>
          <p className={styles.bet_title}>{props.bet_title}</p>
          <p className={styles.bet_amount}>{props.bet_amount}</p>
        </div>
        <div className={styles.team_container}>
          <img className={styles.team_logo} src={props?.team_logo?.data?.attributes?.url} alt="" />
          <div className={styles.coefficient_container}>
            <p className={styles.team_name}>{props.team_name}</p>
            <p className={styles.coefficient}>{props.coefficient}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReplayPreviewSport;
